 

import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import "../styles/StackQueue.css"
import Button from "../../shared/Button"
import StackVisualizer from "./StackVisualizer"
import QueueVisualizer from "./QueueVisualizer"
import InfoPanel from "./InfoPanel"
import Header from "./Header"
import ComparisonLogs from "./ComparisonLogs"
import StepByStepGuide from "./StepByStepGuide"

function StackQueue() {
  const [activeTab, setActiveTab] = useState("stack")
  const [logs, setLogs] = useState([])
  const [currentStep, setCurrentStep] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(false)
  const [speed, setSpeed] = useState(1000) // milliseconds between steps
  const [showStepGuide, setShowStepGuide] = useState(false)

  const addLog = (message, type = "info") => {
    setLogs((prevLogs) => [...prevLogs, { message, type, timestamp: new Date().toLocaleTimeString() }])
  }

  const clearLogs = () => {
    setLogs([])
    setCurrentStep(0)
  }

  const handleAutoPlay = () => {
    if (isAutoPlaying) {
      setIsAutoPlaying(false)
      return
    }

    setIsAutoPlaying(true)
    const interval = setInterval(() => {
      setCurrentStep((prev) => {
        const next = prev + 1
        if (next >= (activeTab === "stack" ? stackSteps.length : queueSteps.length)) {
          setIsAutoPlaying(false)
          clearInterval(interval)
          return prev
        }
        return next
      })
    }, speed)

    return () => clearInterval(interval)
  }

  const stackSteps = [
    {
      title: "Initialize Empty Stack",
      description: "A stack starts empty. It follows the Last-In-First-Out (LIFO) principle.",
    },
    { title: "Push Operation", description: "When you push an element, it goes on top of the stack." },
    { title: "Another Push", description: "Each new element is placed on top of the previous elements." },
    { title: "Pop Operation", description: "When you pop, the topmost element is removed and returned." },
    { title: "Stack State", description: "After operations, you can see the current state of the stack." },
  ]

  const queueSteps = [
    {
      title: "Initialize Empty Queue",
      description: "A queue starts empty. It follows the First-In-First-Out (FIFO) principle.",
    },
    { title: "Enqueue Operation", description: "When you enqueue an element, it joins at the end of the queue." },
    { title: "Another Enqueue", description: "Each new element is placed at the end of the queue." },
    { title: "Dequeue Operation", description: "When you dequeue, the element at the front is removed and returned." },
    { title: "Queue State", description: "After operations, you can see the current state of the queue." },
  ]

  const handlePrevStep = () => {
    setCurrentStep((prev) => Math.max(0, prev - 1))
  }

  const handleNextStep = () => {
    setCurrentStep((prev) => {
      const max = activeTab === "stack" ? stackSteps.length - 1 : queueSteps.length - 1
      return Math.min(max, prev + 1)
    })
  }

  return (
    <div style={{ background: '#0d1b2a', minHeight: '100vh', width: '100%' }}>
    <div className="stackapp-container">
      <Header />

      <div className="stackcontrol-panel">
        <div className="stacktabs">
          <button className={`stacktab ${activeTab === "stack" ? "active" : ""}`} onClick={() => { setActiveTab("stack"); clearLogs(); setShowStepGuide(false); }}>Stack Visualization</button>
          <button className={`stacktab ${activeTab === "queue" ? "active" : ""}`} onClick={() => { setActiveTab("queue"); clearLogs(); setShowStepGuide(false); }}>Queue Visualization</button>
        </div>

        {/* <div className="step-controls">
          <button className="step-button guide-button" onClick={() => setShowStepGuide(!showStepGuide)}>
            {showStepGuide ? "Hide Guide" : "Show Step-by-Step Guide"}
          </button>

          {showStepGuide && (
            <>
              <button className="step-button" onClick={handlePrevStep} disabled={currentStep === 0}>
                Previous
              </button>
              <button className="step-button" onClick={handleAutoPlay}>
                {isAutoPlaying ? "Pause" : "Auto Play"}
              </button>
              <button
                className="step-button"
                onClick={handleNextStep}
                disabled={currentStep === (activeTab === "stack" ? stackSteps.length - 1 : queueSteps.length - 1)}
              >
                Next
              </button>
              <div className="speed-control">
                <label>Speed:</label>
                <input
                  type="range"
                  min="200"
                  max="2000"
                  step="100"
                  value={speed}
                  onChange={(e) => setSpeed(Number(e.target.value))}
                />
              </div>
            </>
          )}
        </div> */}
      </div>

      <div className="stackmain-content">
        {showStepGuide && (
          <StepByStepGuide steps={activeTab === "stack" ? stackSteps : queueSteps} currentStep={currentStep} />
        )}

        <div className="visualization-container">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              className="visualization-wrapper"
            >
              {activeTab === "stack" ? (
                <StackVisualizer addLog={addLog} currentStep={showStepGuide ? currentStep : null} />
              ) : (
                <QueueVisualizer addLog={addLog} currentStep={showStepGuide ? currentStep : null} />
              )}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="side-panel">
          <InfoPanel type={activeTab} />

          <ComparisonLogs logs={logs} />
        </div>
      </div>
    </div>
    </div>
  )
}


export default StackQueue

